import React, { CSSProperties } from 'react';

import aiRobotImage from 'assets/images/ai-robot.png';

interface AIBotProps {
  style?: CSSProperties;
  className?: string;
}

const AIBot: React.FC<AIBotProps> = ({ style, className }) => {
  const size = style?.fontSize || 24;

  return (
    <img
      src={aiRobotImage}
      alt="AI Bot"
      className={className}
      style={{
        width: size,
        height: size,
        ...style,
        fontSize: undefined,
      }}
    />
  );
};

export default AIBot;
